import { Vue } from './config'
import CurrencyInput from '../components/CurrencyInput'

if (document.getElementById('vue-incomecalc')) {
    var fund = new Vue({
        el: '#vue-incomecalc',
        components: {
            CurrencyInput
        },
        data: {
            compound: true,
            initialInvestment: 10000,
            yearlyInvestment: 0,
            intRate: 5.0,
            withdrawYear: 0,
            currentYear: new Date().getFullYear()
        },
        methods: {
            formatNum(val) {
                return val.toLocaleString('en-GB', { maximumFractionDigits: 2 })
            }
        },
        computed: {
            total: function () {
                if (this.compound) {
                    var r = this.intRate / 100 / 365,
                        C = this.yearlyInvestment,
                        P = this.initialInvestment,
                        y = this.years,
                        d = 365 * y,
                        n = 364,
                        total = P + C,//add initial contribution to account for loss of interest
                        ri = 0

                    var yr = new Date().getFullYear()
                    var count = 0
                    var initialDeposit = true
                    var z
                    var zz

                    while (count++ < d) {
                        z = new Date(yr, 0, count)
                        zz = new Date(yr, 0, count + 1)

                        if (count % n === 0) {
                            if (!initialDeposit) {
                                total += C
                            } else {
                                initialDeposit = false
                            }
                        }

                        if (zz.getDate() < z.getDate()) {
                            total += ri
                            ri = 0
                        }

                        ri += total * r
                    }
                    return Math.round(total, 2)
                } else {
                    var rate = (this.intRate / 100)
                    var A = Math.round((this.initialInvestment * rate) * this.years)
                    return (A + this.initialInvestment)
                }
            },
            totalInvestment() {
                return this.formatNum(this.yearlyInvestment * this.years)
            },
            result() {
                return this.formatNum(this.total)
            },
            years() {
                return this.withdrawYear - this.currentYear
            },
            growth() {
                return this.formatNum(this.total - this.initialInvestment - (this.years * this.yearlyInvestment))
            }
        },
        mounted: function () {
            this.withdrawYear = this.currentYear + 10
        },
    })
}